import React, { useRef, useState } from 'react';
import WalletCard from '../../../../../../components/WalletCard/WalletCard';

import PiggybankWTAC from '../../../../../../assets/icons/PiggybankWTAC.svg';

import failureIcon from '../../../../../../assets/icons/failureIcon.svg';
import successIcon from '../../../../../../assets/icons/succesIcon.svg';
import updateMemo from '../../../../../../assets/icons/updateMemo.svg';
import Info from '../../../../../../assets/icons/Info.svg';
import trashIcon from '../../../../../../assets/icons/trashr.svg';
import reverseIcon from '../../../../../../assets/icons/reverseTransactions.svg';
import NoData from '../../../../../../components/NoData/NoData';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import SideSheet from '../../../../../../components/SideSheet/SideSheet';
import HouseMoneySidesheet from '../../Sidesheets/HouseMoney/HouseMoneySidesheet';
import TransactionDetailsAlt from '../../../../../../components/NewSideSheet/TransactionDetailsAlt/TransactionDetailsAlt';
import usePiggybank from '../../../../../../hooks/usePiggybank';
import { LuMoreVertical } from 'react-icons/lu';
import { convertToNaira, useOutsideClick } from '../../../../../../helpers/utils';
import Dropdown from '../../../../../../components/Dropdown/Dropdown';
import ModalDeleteTransaction from '../../../../../../components/Modals/ModalDeleteTransaction';
import ModalUpdateTransactionMemo from '../../../../../../components/Modals/ModalUpdateTransactionMemo';
import useTransaction from '../../../../../../hooks/useTransaction';
import Pagination from '../../../../../../components/Pagination/Pagination';
import ModalTransactionSearch from '../../../../../../components/Modals/ModalTransactionSearch';
import InterestBreakdown from '../../../../../../components/InterestBreakdown/InterestBreakdown';
import { Loader } from '@piggytechng/component-library';
import { AppliedTransactionSearch, PiggybankWithdrawalDays } from '../../../../../../types';

const index = () => {
  const [showWalletBalance] = useState(true);
  const {
    piggybankBalanceQ,
    piggybankTransactionsQ,
    refetchPiggybankTransactionsQ,
    piggybankWalletDataQ,
    toggleAutosave,
    autosaveToggleHistoryQ,
    autosaveToggleHistoryPagination,
    isLoadingAutosaveToggleHistoryQ,
    autosaveToggleHistoryParams,
    setAutosaveToggleHistoryParams,
    searchPiggybankTransactions,
    clearPiggybankSearch,
    searchedPiggybankTransactions,
    isSearchingPiggybank,
  } = usePiggybank();
  const { deleteTransaction, updateTransactionMemo, isLoading: isTransactionLoading } = useTransaction();
  const navigate = useNavigate();

  const params = useParams();
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [appliedSearch, setAppliedSearch] = useState<AppliedTransactionSearch | null>(null);
  const [showHouseMoneySideSheet, setShowHouseMoneySideSheet] = useState(false);
  const [activeHistoryTab, setActiveHistoryTab] = useState<'wallet' | 'autosave-toggle' | 'interest-breakdown'>(
    'wallet',
  );
  const [show, setShow] = useState(false);
  const [trDetails, setTrDetails] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTransactionRef, setSelectedTransactionRef] = useState<string>('');
  const [showUpdateMemoModal, setShowUpdateMemoModal] = useState(false);
  const [selectedTransactionForMemo, setSelectedTransactionForMemo] = useState<{ reference: string; memo: string }>({
    reference: '',
    memo: '',
  });
  const [showDropdown, setShowDropdown] = useState({
    index: -1,
    show: false,
  });

  const walletKey = 'piggybank';

  const formatTimestamp = (ts?: number | null) => (ts ? dayjs.unix(ts).format('D MMM, YYYY') : 'None');

  const capitalize = (str?: string) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : '');

  const autosave = piggybankWalletDataQ?.autosave || { isActive: false, amount: 0, frequency: 'Days' };
  const [togglingAutosave, setTogglingAutosave] = useState(false);

  const handleToggleAutosave = async () => {
    if (togglingAutosave) return;
    setTogglingAutosave(true);
    const newStatus = !autosave.isActive;
    await toggleAutosave(id, newStatus);
    setTogglingAutosave(false);
  };
  const withdrawalDays: PiggybankWithdrawalDays | undefined = piggybankWalletDataQ?.withdrawalDays;
  const customDay = withdrawalDays?.customDay;
  const isCustomDay = !!customDay && customDay.active && withdrawalDays?.isDefault === false;
  const customDayTs = customDay?.expectedDate ?? withdrawalDays?.nextWithdrawalDay;
  const withdrawalDaySetting = isCustomDay ? (
    <>
      Custom:{' '}
      {customDayTs
        ? formatTimestamp(customDayTs)
        : dayjs(new Date(2000, customDay.month - 1, customDay.day)).format('D MMM')}
      {(customDay.setAt || customDay.memo) && (
        <small className="wallet-card-caption">
          {customDay.setAt ? `set ${formatTimestamp(customDay.setAt)}` : ''}
          {customDay.setAt && customDay.memo ? ' | ' : ''}
          {customDay.memo || ''}
        </small>
      )}
    </>
  ) : (
    'PiggyVest days (default)'
  );
  const lastFreeWithdrawal = withdrawalDays?.previousWithdrawalDay ? (
    <>
      {formatTimestamp(withdrawalDays.previousWithdrawalDay)}
      {withdrawalDays.lastFreeWithdrawalSource === 'first_transaction' ? (
        <small className="wallet-card-caption">first transaction</small>
      ) : null}
    </>
  ) : (
    'None yet'
  );

  const dropdownRef = useRef(null);
  const actionRef = useRef(null);
  useOutsideClick(dropdownRef, setShowDropdown, actionRef);

  const walletCardsData: any = [
    {
      title: 'Piggybank Total Balance:',
      balanceKey: piggybankBalanceQ?.balance ?? 0,
      cardId: 'hm-card',
      image: PiggybankWTAC,
      isActive: true,
      isOpenSideSheet: true,
      // cardClick: () => setShowHouseMoneySideSheet(Object.keys(houseMoneyDetails).length ? true : false),
    },
    {
      title: 'Last Free Withdrawal',
      cardId: 'pb-last-withdrawal',
      image: PiggybankWTAC,
      isActive: true,
      isBalance: false,
      isText: true,
      text: lastFreeWithdrawal,
    },
    {
      title: 'Next Free Withdrawal Day',
      cardId: 'pb-next-withdrawal',
      image: PiggybankWTAC,
      isActive: true,
      isBalance: false,
      isText: true,
      text: formatTimestamp(withdrawalDays?.nextWithdrawalDay),
    },
    {
      title: 'Withdrawal Day Setting',
      cardId: 'pb-withdrawal-day-setting',
      image: PiggybankWTAC,
      isActive: true,
      isBalance: false,
      isText: true,
      text: withdrawalDaySetting,
    },
  ];
  LuMoreVertical;

  const walletTransactions = searchedPiggybankTransactions ?? piggybankTransactionsQ?.results;

  const handleApplySearch = (filter: string, value: string, display: string) => {
    setAppliedSearch({ filter, query: value, display });
    searchPiggybankTransactions(value, filter);
    setShowSearchModal(false);
  };

  const handleResetSearch = () => {
    setAppliedSearch(null);
    clearPiggybankSearch();
  };

  const id = params.id as string;

  const formatData = (data: any) => ({
    transactionId: data.asw_id,
    owner: data.asw_own,
    plan: data.asw_plan,
    amount: convertToNaira(data.asw_value * 100),
    memo: data.asw_memo,
    unique: data.asw_unique,
    type: data.asw_type,
    reference: data.asw_ref,
    balance: convertToNaira(data.asw_balance * 100),
    date: dayjs.unix(data.asw_date).format('D MMM YYYY | h:mm A'),
  });

  const handleShowTransactionsDetails = (data: any) => {
    const formattedData = formatData(data);

    setShow(true);
    setTrDetails(formattedData);
  };

  const handleDeleteTransaction = (reference: string) => {
    setSelectedTransactionRef(reference);
    setShowDeleteModal(true);
  };

  const handleDeleteSuccess = () => {
    refetchPiggybankTransactionsQ();
  };

  const handleUpdateMemo = (reference: string, currentMemo: string) => {
    setSelectedTransactionForMemo({ reference, memo: currentMemo });
    setShowUpdateMemoModal(true);
  };

  const handleUpdateMemoSuccess = () => {
    refetchPiggybankTransactionsQ();
  };

  const handleShowDropdown = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, i: number) => {
    e.stopPropagation();
    if (i === showDropdown.index) {
      setShowDropdown({ ...showDropdown, show: false, index: -1 });
    } else {
      setShowDropdown({ ...showDropdown, show: true, index: i });
    }

    const formattedData = formatData(piggybankTransactionsQ?.results[i]);

    console.log(formattedData, 'formattedData');

    setTrDetails(formattedData);
  };

  const getDropdownArray = (reference: string, currentMemo: string) => [
    {
      icon: updateMemo,
      text: 'Update memo',
      fn: () => handleUpdateMemo(reference, currentMemo),
    },
    {
      icon: Info,
      text: 'See more info',
      fn: () => setShow(true),
    },
    {
      icon: trashIcon,
      text: 'Delete transaction',
      fn: () => handleDeleteTransaction(reference),
    },
    {
      icon: reverseIcon,
      text: 'Reverse transaction',
      fn: () => console.log('run'),
    },
  ];

  return (
    <>
      <div>
        <div className="piggybank-autosave-row">
          <div
            className={`piggybank-autosave-label ${
              autosave?.isActive ? 'piggybank-autosave-label--active' : 'piggybank-autosave-label--inactive'
            }`}
          >
            <span className="piggybank-autosave-label__dot" aria-hidden />
            <span className="piggybank-autosave-label__title">Autosave</span>
            <span className="piggybank-autosave-label__status">{autosave?.isActive ? 'Active' : 'Inactive'}</span>
            {autosave?.isActive && (
              <>
                <span className="piggybank-autosave-label__divider" aria-hidden />
                <span className="piggybank-autosave-label__details">
                  <span className="piggybank-autosave-label__amount">
                    {convertToNaira((autosave.amount ?? 0) * 100)}
                  </span>
                  <span className="piggybank-autosave-label__sep">/</span>
                  <span className="piggybank-autosave-label__frequency">{capitalize(autosave.frequency)}</span>
                </span>
              </>
            )}
          </div>
          <div className="piggybank-autosave-toggle-wrapper" onClick={handleToggleAutosave} role="button" tabIndex={0}>
            <span className="piggybank-autosave-toggle-wrapper__label">
              {autosave?.isActive ? 'Disable Autosave' : 'Enable Autosave'}
            </span>
            <button
              className={`piggybank-autosave-toggle ${autosave?.isActive ? 'piggybank-autosave-toggle--active' : ''}`}
              disabled={togglingAutosave}
              tabIndex={-1}
            >
              <span className="piggybank-autosave-toggle__knob" />
            </button>
          </div>
        </div>
        <div className="cards-container flex--2" style={{ flexWrap: 'wrap', gap: '0.5rem' }}>
          {walletCardsData.map((item: any, i: any) => (
            <WalletCard
              key={i}
              {...item}
              showBalance={showWalletBalance}
              balance={item.balanceKey}
              walletKey={walletKey}
            />
          ))}
        </div>
        <div className="wallets-details">
          <div className="history-tab-switch piggybank">
            <span
              className={`history-pill${activeHistoryTab === 'wallet' ? ' active' : ''}`}
              onClick={() => setActiveHistoryTab('wallet')}
            >
              Wallet History
            </span>

            <span
              className={`history-pill${activeHistoryTab === 'autosave-toggle' ? ' active' : ''}`}
              onClick={() => setActiveHistoryTab('autosave-toggle')}
            >
              Autosave Toggle History
            </span>

            <span
              className={`history-pill${activeHistoryTab === 'interest-breakdown' ? ' active' : ''}`}
              onClick={() => setActiveHistoryTab('interest-breakdown')}
            >
              Interest Breakdown
            </span>

            {activeHistoryTab === 'wallet' && (
              <p className="view-all-g" onClick={() => navigate(`/piggybank-transactions/${id}`)}>
                View all
              </p>
            )}
          </div>

          {activeHistoryTab === 'wallet' && (
            <div className="customers-filter">
              <div className="input-field">
                <input
                  type="text"
                  readOnly
                  placeholder="Search transactions"
                  value={
                    appliedSearch
                      ? `${appliedSearch.filter.charAt(0).toUpperCase() + appliedSearch.filter.slice(1)}: ${
                          appliedSearch.display
                        }`
                      : ''
                  }
                  onClick={() => setShowSearchModal(true)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
              <div className="query-filter" onClick={() => setShowSearchModal(true)}>
                <div>
                  <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                      stroke="#1E293B"
                      strokeWidth="1.5"
                      strokeLinecap="square"
                    />
                  </svg>
                </div>
                <div>Search</div>
              </div>
              <div className="query-filter" onClick={handleResetSearch}>
                <div></div>
                <div>Reset</div>
              </div>
            </div>
          )}
        </div>

        {activeHistoryTab === 'wallet' && isSearchingPiggybank ? (
          <div className="page-loader">
            <Loader color="#1734ca" />
          </div>
        ) : null}

        {activeHistoryTab === 'wallet' &&
          !isSearchingPiggybank &&
          (walletTransactions?.length ? (
            <div className="table-container housemoney piggybank">
              <table className="table">
                <thead className="table_head">
                  <tr>
                    {/* <th className="icon">{''}</th> */}
                    <small></small>
                    <th className="date">Date</th>
                    <th className="amount">{`Amount (₦)`}</th>
                    <th className="balance">{`Balance (₦)`}</th>
                    <th className="memo">Memo</th>
                    <th className="transactionID">Transaction ID</th>
                  </tr>
                </thead>

                <tbody className="table-body">
                  {(searchedPiggybankTransactions ?? piggybankTransactionsQ?.results?.slice(0, 5))?.map(
                    (txn: any, i: number) => {
                      const isCredit = txn.asw_value > 0;

                      return (
                        <tr key={txn.asw_id} className="table-row" onClick={() => handleShowTransactionsDetails(txn)}>
                          {/* <td className="icon">
                      </td> */}
                          <img src={isCredit ? successIcon : failureIcon} alt={isCredit ? 'credit' : 'debit'} />
                          <td>{dayjs.unix(txn.asw_date).format('D MMM YYYY | h:mm A')}</td>
                          <td>
                            {isCredit ? '+' + convertToNaira(txn.asw_value * 100) : convertToNaira(txn.asw_value * 100)}
                          </td>
                          <td className="balance">{convertToNaira(txn.asw_balance * 100)}</td>
                          <td className="memo">{txn.asw_memo}</td>
                          <td className="tr-id">{txn.asw_ref}</td>

                          {/* <td className="chevron-cell">
                        <img className="chevron-table" src={chevronTable} />
                      </td> */}

                          <div className="dropdown-container" ref={actionRef}>
                            <button onClick={(e) => handleShowDropdown(e, i)} className="pointer">
                              <LuMoreVertical color="#CBD5E1" size={25} />
                            </button>

                            {showDropdown.index === i && showDropdown.show && (
                              <div className="table-dropdown" ref={dropdownRef}>
                                <Dropdown data={getDropdownArray(txn.asw_ref, txn.asw_memo || '')} index={i} />
                              </div>
                            )}
                          </div>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <NoData message={'No transaction at the moment.'} />
          ))}

        {activeHistoryTab === 'autosave-toggle' && (
          <>
            {isLoadingAutosaveToggleHistoryQ ? (
              <div className="page-loader">
                <Loader color="#1734ca" />
              </div>
            ) : autosaveToggleHistoryQ?.length ? (
              <div className="table-container housemoney piggybank">
                <table className="table">
                  <thead className="table_head">
                    <tr>
                      <th className="date">Date</th>
                      <th>Action</th>
                      <th>Type</th>
                      <th>Unique ID</th>
                    </tr>
                  </thead>

                  <tbody className="table-body">
                    {autosaveToggleHistoryQ.map((entry: any, idx: number) => (
                      <tr key={entry.uniqueid || idx} className="table-row">
                        <td>{dayjs.unix(entry.date).format('D MMM YYYY | h:mm A')}</td>
                        <td>{capitalize(entry.action)}</td>
                        <td>{capitalize(entry.type)}</td>
                        <td>{entry.uniqueid}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <NoData message={'No autosave toggle history at the moment.'} />
            )}

            {autosaveToggleHistoryPagination?.total ? (
              <Pagination
                currentPage={autosaveToggleHistoryPagination.page ?? autosaveToggleHistoryParams.page}
                totalPages={autosaveToggleHistoryPagination.totalPages}
                onPageChange={(page) => setAutosaveToggleHistoryParams((prev) => ({ ...prev, page }))}
                limit={autosaveToggleHistoryParams.limit}
                onLimitChange={(newLimit) => setAutosaveToggleHistoryParams({ page: 1, limit: newLimit })}
              />
            ) : null}
          </>
        )}

        {activeHistoryTab === 'interest-breakdown' && <InterestBreakdown walletName="piggybank" />}
      </div>

      {showHouseMoneySideSheet && (
        <SideSheet active={showHouseMoneySideSheet} onClose={() => setShowHouseMoneySideSheet(false)} hideCloseButton>
          <HouseMoneySidesheet userId={id} onClose={() => setShowHouseMoneySideSheet(false)}></HouseMoneySidesheet>
        </SideSheet>
      )}

      <ModalTransactionSearch
        modalIsOpen={showSearchModal}
        setIsOpen={setShowSearchModal}
        onApply={handleApplySearch}
        onClear={handleResetSearch}
        isLoading={isSearchingPiggybank}
        initialFilter={appliedSearch?.filter}
        initialQuery={appliedSearch?.query}
      />

      <TransactionDetailsAlt
        show={show}
        id={''}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />
      {selectedTransactionRef && (
        <ModalDeleteTransaction
          modalIsOpen={showDeleteModal}
          setIsOpen={setShowDeleteModal}
          reference={selectedTransactionRef}
          wallet="piggybank"
          onDelete={deleteTransaction}
          onSuccess={handleDeleteSuccess}
          isLoading={isTransactionLoading}
        />
      )}
      {selectedTransactionForMemo.reference && (
        <ModalUpdateTransactionMemo
          modalIsOpen={showUpdateMemoModal}
          setIsOpen={setShowUpdateMemoModal}
          reference={selectedTransactionForMemo.reference}
          wallet="piggybank"
          currentMemo={selectedTransactionForMemo.memo}
          onUpdate={updateTransactionMemo}
          onSuccess={handleUpdateMemoSuccess}
          isLoading={isTransactionLoading}
        />
      )}
    </>
  );
};

export default index;
